import type { FaireProductEntity } from "../../entity_types/product";

export const p_ek8n8pytku: FaireProductEntity = {
  token: "p_ek8n8pytku",
  type: "product",
  name: "Blueberry Boogie",
  brandToken: "b_ks599psfse",
  brandName: "Psychedelic Pepper Company",
  imageUrl:
    "https://cdn.faire.com/fastly/d997863fcb18da761a05b36383bdadacfd2115f3c835e3e11580721c6c02a90c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d98d4ecbafc10412f0911b27536a0fbb7ae16c8255068e4d684e4b9e8e6c40d.jpeg",
  ],
  priceDollars: 4.65,
  description:
    "Something groovy happens when you ferment peppers and fruit for 30 days! This fermented blueberry hot sauce is a must have. This sauce pairs well with chicken, pork and beef! Slather some on your tacos and let the party begin!",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:15.199Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
